import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import AlertElement from './UI/Alert/Alert';
import ModalMessageElement from './UI/ModalMessage/ModalMessage';
import ModalFormElement from './UI/ModalForm/ModalForm';
import "./Users.css";
import axios from 'axios';

export class Users extends Component {
    displayName = Users.name
    constructor(props) {
        super(props);
        this.state = {
            forecasts: [],
            loading: false,
            showmodal: false,
            classMessageTitle: 'alert-primary',
            showmodalform: false,
            modaltitle: '',
            modalbody: '',
            orderType: 'name',
            orderDirection: true,
            matricola: '',
            formsconfig:
            {
                show: false,
                type: 0,
            },
            filterform: {
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'Nome o Matricola'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                }
            },
            objform: {
                id: {
                    elementType: 'hidden',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Identificativo'
                    },
                    value: '0',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                name: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Nome utente'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                email: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Email'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                password: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'password',
                        placeholder: 'Password'
                    },
                    value: '',
                    validation: {
                        required: true,
                        minLength: 6,
                        maxLength: 10,
                        isNumeric: true
                    },
                    valid: false,
                    touched: false
                },
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Matricola'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                codiceSocieta: {
                    elementType: 'hidden',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Codice'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
		        satispay_accredito: {
                    elementType: 'select',
                    value: 0,
                    elementConfig: {
                        placeholder: 'Accredito Satispay:',
                        options: [
                            { value: '0', displayValue: 'Non definito' },
                            { value: '1', displayValue: 'Diretto al cliente' },
                            { value: '3', displayValue: 'Euronet Diretto' },
                            { value: '5', displayValue: 'Bonifio al cliente' },
                            { value: '99', displayValue: 'Disabilitato' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                satispay_keyid: {
                    elementType: 'hidden',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Satispay keyId:'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
                bancomat_accredito: {
                    elementType: 'select',
                    value: 2,
                    elementConfig: {
                        placeholder: 'Accredito:',
                        options: [
                            { value: '0', displayValue: 'Non Definito' },
                            { value: '3', displayValue: 'Euronet Diretto' },
                            { value: '5', displayValue: 'Bonifico Giornaliero' },
                            { value: '6', displayValue: 'Bonifico Settimanale' },
                            //{ value: '7', displayValue: 'Bonifio 2w' },
                            { value: '8', displayValue: 'Bonifico Mensile' },
                            //{ value: '9', displayValue: 'Bonifio 3m' },
                            { value: '98', displayValue: 'Non configurato' },
                            { value: '99',displayValue: 'Disabilitato' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                deadline: {
                    elementType: 'hidden',
                    elementConfig: {
                        type: 'number',
                        step: '1',
                        max: '5000',
                        min: '50',
                        placeholder: 'Soglia invio bonifico'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                },
            },
            modalform: {
                codiceAttivazione: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Codice Attivazione'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                }
            },
            formIsValid: false,
        };
        this.filterCustom = this.filterCustom.bind(this);
        //this.refresh();
    }
    refresh() {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
        })
        axios.post('api/User/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({ forecasts: respose.data, loading: false });
                this.orderCustom(respose.data);
            })
            .catch(data => {
            });
    }
    clickModalOk() {
        this.state.showmodal = false;
        this.state.showerror = false;
        this.forceRender();
    }
    clickModalCancel() {
        this.state.showmodal = false;
        this.state.showmodalform = false;
        this.state.showerror = false;
        this.forceRender();
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    ModalFormShow = (event, satispayuser) => {
        this.state.showmodalform = true;
        this.state.satispayuser = satispayuser;
        this.forceRender();
    }
    TestSatispayFetch = (event, satispayuser) => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: satispayuser.id,
                Name: satispayuser.name,
                Password: satispayuser.password,
                CodiceSocieta: satispayuser.codiceSocieta,
                Matricola: satispayuser.matricola,
                Email: satispayuser.email,
                DeadlinePagamento: satispayuser.deadline,
                Satispay_Accredito: satispayuser.satispay_accredito,
                Satispay_KeyId: satispayuser.satispay_keyid,
                Bancomat_Accredito: satispayuser.bancomat_accredito
            }
        })
        axios.post('api/User/TestSatispay', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState(prevState => {
                    let updatingstate = Object.assign({}, prevState);
                    if (respose.data.esito == false) {
                        this.state.classMessageTitle = 'alert-danger';
                    }
                    else {
                        this.state.classMessageTitle = 'alert-success';
                    }
                    this.state.showmodal = true;
                    this.state.modaltitle = "Test satispay matricola:" + satispayuser.matricola;
                    this.state.modalbody = respose.data.message;

                    return { updatingstate };
                })
                this.refresh();
            })
    }
    AuthSatispayFetch = (event, satispayuser, token) => {
        this.state.showmodalform = false;
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            User: this.state.satispayuser,
            Token_Satispay: this.state.modalform.codiceAttivazione.value,
        })
        axios.post('api/User/AuthSatispay', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState(prevState => {
                    let updatingstate = Object.assign({}, prevState);
                    this.state.showmodal = true;
                    this.state.modaltitle = "Registrazione satispay matricola:" + this.state.satispayuser.matricola;
                    if (respose.data.esito == false) {
                        this.state.modalbody = "Errore durante la registrazione";
                        this.state.classMessageTitle = 'alert-danger';
                    }
                    else {
                        this.state.modalbody = "Utente registrato con Key Id:" + respose.data.key_id;
                        this.state.classMessageTitle = 'alert-success';
                    }
                    return { updatingstate };
                })
                this.refresh();
            })
    }
    ModificaFetch = event => {
        this.clickdismiss();
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: this.state.objform.id.value,
                Name: this.state.objform.name.value,
                Password: this.state.objform.password.value,
                CodiceSocieta: this.state.objform.codiceSocieta.value,
                Matricola: this.state.objform.matricola.value,
                Email: this.state.objform.email.value,
                DeadlinePagamento: this.state.objform.deadline.value,
                Satispay_Accredito: this.state.objform.satispay_accredito.value,
                Satispay_KeyId: this.state.objform.satispay_keyid.value,
                Bancomat_Accredito: this.state.objform.bancomat_accredito.value
            }
        })
        axios.post('api/User/Modify', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                if (respose.data != '' && respose.data != 'OK') {
                    this.state.showerror = true;
                    this.state.errorheader = 'Errore modifica:';
                    this.state.errortext = respose.data;
                } else {
                    this.setState(prevState => {
                        let updatingstate = Object.assign({}, prevState);
                        updatingstate.formsconfig.show = false;
                        return { updatingstate };
                    })
                }
                this.refresh();
            })
    }
    InserisciFetch = event => {
        this.clickdismiss();
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: this.state.objform.id.value,
                Name: this.state.objform.name.value,
                Password: this.state.objform.password.value,
                CodiceSocieta: this.state.objform.codiceSocieta.value,
                Matricola: this.state.objform.matricola.value,
                Email: this.state.objform.email.value,
                DeadlinePagamento: this.state.objform.deadline.value,
                Satispay_Accredito: this.state.objform.satispay_accredito.value,
                Satispay_KeyId: this.state.objform.satispay_keyid.value,
                Bancomat_Accredito: this.state.objform.bancomat_accredito.value
            }
        })
        axios.post('api/User/Insert', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                if (respose.data != '' && respose.data != 'OK') {
                    this.state.showerror = true;
                    this.state.errorheader = 'Errore inserimento:';
                    this.state.errortext = respose.data;
                } else {
                    this.setState(prevState => {
                        let updatingstate = Object.assign({}, prevState);
                        updatingstate.formsconfig.show = false;
                        return { updatingstate };
                    })
                }
                this.refresh();
            })
    }
    EliminaFetch = event => {
        this.clickdismiss();
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Content:
            {
                Id: this.state.objform.id.value,
                Name: this.state.objform.name.value,
                Password: this.state.objform.password.value,
                CodiceSocieta: this.state.objform.codiceSocieta.value,
                Matricola: this.state.objform.matricola.value,
                Email: this.state.objform.email.value,
                DeadlinePagamento: this.state.objform.deadline.value,
                Satispay_Accredito: this.state.objform.satispay_accredito.value,
                Satispay_KeyId: this.state.objform.satispay_keyid.value,
                Bancomat_Accredito: this.state.objform.bancomat_accredito.value
            }
        })
        axios.post('api/User/Delete', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState(prevState => {
                    let updatingstate = Object.assign({}, prevState);
                    updatingstate.formsconfig.show = false;
                    return { updatingstate };
                })
                this.refresh();
            })
    }
    Nuovo = event => {
        this.clickdismiss();
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.id.value = '0';
            updatingstate.objform.name.value = '';
            updatingstate.objform.email.value = '';
            updatingstate.objform.password.value = '';
            updatingstate.objform.codiceSocieta.value = '';
            updatingstate.objform.matricola.value = '';
            updatingstate.objform.deadline.value = 100;
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 1;
            updatingstate.objform.satispay_keyid.value = '';
            updatingstate.objform.bancomat_accredito.value = 3;
            updatingstate.objform.satispay_accredito.value = 0;
            return { updatingstate };
        })
    }
    Modifica = (event, modifing) => {
        window.scrollTo(0, 0);
        this.clickdismiss();
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.id.value = modifing.id;
            updatingstate.objform.name.value = modifing.name;
            updatingstate.objform.email.value = modifing.email;
            updatingstate.objform.password.value = modifing.password;
            updatingstate.objform.codiceSocieta.value = modifing.codiceSocieta;
            updatingstate.objform.matricola.value = modifing.matricola;
            updatingstate.objform.deadline.value = modifing.deadlinePagamento;
            updatingstate.objform.satispay_accredito.value = modifing.satispay_accredito;
            if (updatingstate.objform.satispay_accredito.value === 1) {
                updatingstate.objform.satispay_keyid.elementType = 'input';
            }
            else {
                updatingstate.objform.satispay_keyid.elementType = 'hidden';
            }
            updatingstate.objform.satispay_keyid.value = modifing.satispay_keyid;
            updatingstate.objform.bancomat_accredito.value = modifing.bancomat_accredito;
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 2;
            return { updatingstate };
        })
    }
    Elimina = (event, deleting) => {
        window.scrollTo(0, 0);
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.id.value = deleting.id;
            updatingstate.objform.name.value = deleting.name;
            updatingstate.objform.email.value = deleting.email;
            updatingstate.objform.password.value = deleting.password;
            updatingstate.objform.codiceSocieta.value = deleting.codiceSocieta;
            updatingstate.objform.matricola.value = deleting.matricola;
            updatingstate.objform.deadline.value = deleting.deadlinePagamento;
            updatingstate.objform.satispay_accredito.value = deleting.satispay_accredito;
            updatingstate.objform.satispay_keyid.value = deleting.satispay_keyid;
            updatingstate.objform.bancomat_accredito.value = deleting.bancomat_accredito;
            updatingstate.formsconfig.show = true;
            updatingstate.formsconfig.type = 3;
            return { updatingstate };
        })
    }
    Chiudi = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.formsconfig.show = false;
            this.state.showerror = false;
            return { updatingstate };
        })
    }
    clickdismiss() {
        this.state.showerror = false;
        this.forceRender();
    }
    filterCustom(value) {
        var result_matricola = true;
        var result_name = true;
        console.log("utente", value);
        result_matricola &= (this.state.filterform.matricola === '' || value.matricola.toUpperCase().includes(this.state.filterform.matricola.value.toUpperCase()));
        result_name &= (this.state.filterform.matricola === '' || value.name.toUpperCase().includes(this.state.filterform.matricola.value.toUpperCase()));
        return result_matricola || result_name;
    }
    orderCustom(array) {
        var direction;
        if (this.state.orderDirection === true)
            direction = -1;
        else
            direction = 1;
        if (this.state.orderType === 'name') {
            return array.sort((a, b) => (a.name > b.name) ? direction : -direction)
        } else if (this.state.orderType === 'matricola') {
            return array.sort((a, b) => (a.matricola > b.matricola) ? direction : -direction)
        } else if (this.state.orderType === 'livello') {
            return array.sort((a, b) => (a.livello > b.livello) ? direction : -direction)
        }
    }
    orderFunction = (event, newtype) => {
        if (newtype === this.state.orderType) { this.state.orderDirection = !this.state.orderDirection }
        this.state.orderType = newtype;
        this.orderCustom(this.state.forecasts);
        this.forceRender();
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        if (inputIdentifier === 'satispay_accredito' && updatedFormElement.value == 1) {
            updatedForm['satispay_keyid'].elementType = 'input';
        }
        if (inputIdentifier === 'satispay_accredito' && updatedFormElement.value != 1) {
            updatedForm['satispay_keyid'].elementType = 'hidden';
        }
        if (inputIdentifier === 'password') {
            if (updatedForm[inputIdentifier].validation.maxLength < event.target.value.length || updatedForm[inputIdentifier].validation.minLength > event.target.value.length) {
                this.state.showerror = true;
                this.state.errorheader = '';
                this.state.errortext = 'La password deve contenere da ' + updatedForm[inputIdentifier].validation.minLength + ' a ' + updatedForm[inputIdentifier].validation.maxLength + ' caratteri';

            } else {
                this.state.showerror = false;
                this.state.errorheader = '';
                this.state.errortext = '';
            }
        } else {
            updatedFormElement.valid = true;
        }
        if (inputIdentifier === 'bancomat_accredito' && (updatedForm[inputIdentifier].value == 3 || updatedForm[inputIdentifier].value == 99)) {
            updatedForm['deadline'].elementType = 'hidden';
        } else {
            updatedForm['deadline'].elementType = 'input';
        }
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid });
    }
    inputFilterHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.filterform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedForm[inputIdentifier] = updatedFormElement;
        this.setState({ filterform: updatedForm });
        //this.forceRender();
    }
    inputModalChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.modalform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.valid = true;
        updatedFormElement.value = event.target.value;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ modalform: updatedForm, formIsValid: formIsValid });
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }

    static renderTable(forecasts, modifyFunction, deleteFunction, testSatispayFunction, authSatispayFunction, filterCustom, orderDirection, orderFunction) {
        return (
            <div className="reducepadding tableFixHead">
                <table className='table responsive-table'>
                    <thead>
                        <tr>
                            <th className="col-xs-2">Matricola<a onClick={(event) => orderFunction(event, 'matricola')}><Glyphicon glyph='sort-by-attributes-alt' /></a>{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'matricola')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-2">Livello<a onClick={(event) => orderFunction(event, 'livello')}><Glyphicon glyph='sort-by-attributes-alt' /></a>{(orderDirection === true) && <a onClick={(event) => orderFunction(event, 'livello')}><Glyphicon glyph='sort-by-attributes' /></a>}</th>
                            <th className="col-xs-3">Satispay</th>
                            <th className="col-xs-3">Bancomat</th>
                            <th className="col-xs-1">Modifica</th>
                            <th className="col-xs-1">Elimina</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            forecasts.filter(filterCustom)
                                .map(forecast =>
                                    <tr key={forecast.id} className={" " + (forecast.bancomat_accredito === 99 ? 'tr-disabled' : '') + (forecast.bancomat_accredito === 98 ? 'tr-notconfigured' : '')}>
                                        <td>{forecast.matricola}</td>
                                        {(forecast.livello === -99) && <td>Amministratore</td>}
                                        {(forecast.livello === 1) && <td>Utente</td>}
										{(forecast.satispay_accredito === 0) && <td>Non definito</td>}
                                        {(forecast.satispay_accredito === 1 && forecast.satispay_keyid != '') && <td><Button onClick={(event) => testSatispayFunction(event, forecast)} type="button" className="btn btn-success">Test</Button></td>}
                                        {(forecast.satispay_accredito === 1 && forecast.satispay_keyid == '') && <td><Button onClick={(event) => authSatispayFunction(event, forecast)} type="button" className="btn btn-warning">Attiva</Button></td>}
                                        {(forecast.satispay_accredito === 2) && <td>Euronet</td>}
                                        {(forecast.satispay_accredito === 3) && <td>Euronet Temp.</td>}
                                        {(forecast.satispay_accredito === 5) && <td>Euronet Dir.</td>}
                                        {(forecast.satispay_accredito === 99) && <td class="td-important">Disabilitato</td>}
                                        {(forecast.bancomat_accredito === 0) && <td>Non definito</td>}
                                        {(forecast.bancomat_accredito === 2) && <td>Euronet Temp.</td>}
                                        {(forecast.bancomat_accredito === 3) && <td>Euronet Dir.</td>}
                                        {(forecast.bancomat_accredito === 5) && <td>Bonifico (1d)</td>}
                                        {(forecast.bancomat_accredito === 6) && <td>Bonifico (1w)</td>}
                                        {(forecast.bancomat_accredito === 7) && <td>Bonifico (2w)</td>}
                                        {(forecast.bancomat_accredito === 8) && <td>Bonifico (1m)</td>}
                                        {(forecast.bancomat_accredito === 9) && <td>Bonifico (3m)</td>}
                                        {(forecast.bancomat_accredito === 98) && <td class="td-notconfigured">Non configurato</td>}
                                        {(forecast.bancomat_accredito === 99) && <td class="td-disabled">Disabilitato</td>}
                                        <td><Button onClick={(event) => modifyFunction(event, forecast)} type="button" className="btn btn-warning"><Glyphicon glyph='edit' /></Button></td>
                                        {(forecast.livello === -99) && <td><Button onClick={(event) => deleteFunction(event, forecast)} type="button" className="btn btn-danger" disabled><Glyphicon glyph='trash' /></Button></td>}
                                        {(forecast.livello === 1) && <td><Button onClick={(event) => deleteFunction(event, forecast)} type="button" className="btn btn-danger"><Glyphicon glyph='trash' /></Button></td>}
                                    </tr>
                                )}
                    </tbody>
                </table>
            </div>
        );
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div className="reducepadding">
                <form>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={this.state.formsconfig.type === 3 ? true : false} />
                    ))}
                </form>
                <div className="row">
                    <div className="col-sm-6 btn-action">
                        {(this.state.formsconfig.type === 1) && <Button block bsSize="large" onClick={(event) => this.InserisciFetch(event)} type="button" className="btn btn-success">  Inserisci </Button>}
                        {(this.state.formsconfig.type === 2) && <Button block bsSize="large" onClick={(event) => this.ModificaFetch(event)} type="button" className="btn btn-warning">  Modifica </Button>}
                        {(this.state.formsconfig.type === 3) && <Button block bsSize="large" onClick={(event) => this.EliminaFetch(event)} type="button" className="btn btn-danger">  Elimina </Button>}
                    </div>
                    <div className="col-sm-6 btn-action">
                        <Button block bsSize="large" onClick={(event) => this.Chiudi(event)} type="button" className="btn btn-secondary">  Chiudi </Button>
                    </div>
                </div>
            </div>
        );
        const filterElementsArray = [];
        for (let key in this.state.filterform) {
            filterElementsArray.push({
                id: key,
                config: this.state.filterform[key]
            });
        }
        let formFilter = (
            <div className="row">
                {filterElementsArray.map(formElement => (
                    <div className="col-sm-3" key={'div' + formElement.id}>
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputFilterHandler(event, formElement.id)}
                            textdisabled={false} />
                    </div>
                ))}
            </div>
        );
        let contents = this.state.loading
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : Users.renderTable(this.state.forecasts, this.Modifica, this.Elimina, this.TestSatispayFetch, this.ModalFormShow, this.filterCustom, this.state.orderDirection, this.orderFunction);

        return (
            <div className="reducepadding">
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <div className="row">
                    <div className="col-sm-9"> <h1>Utenti</h1> </div>
                    {formFilter}
                </div>
                {(this.state.formsconfig.show === true) && formInser}
                {(this.state.formsconfig.show === false) &&
                    <Button block bsSize="large" onClick={(event) => this.Nuovo(event)} type="button" className="btn btn-success btn-action col-sm-6">  Nuovo Utente </Button>
                }
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
                <span></span>
                {contents}
                <ModalMessageElement
                    classTitle={this.state.classMessageTitle}
                    showmodal={this.state.showmodal}
                    title={this.state.modaltitle}
                    body={this.state.modalbody}
                    isqrcode={true}
                    clickedOk={(event) => this.clickModalOk(event)}
                    clickedCancel={(event) => this.clickModalCancel(event)} />
                <ModalFormElement showmodal={this.state.showmodalform} title='Attivazione Satispay' objform={this.state.modalform} clickedOk={(event) => this.AuthSatispayFetch(event)} inputEvent={(event, inputIdentifier) => this.inputModalChangedHandler(event, inputIdentifier)} clickedCancel={(event) => this.clickModalCancel(event)} />
            </div>
        );
    }
}
